import styled from 'styled-components';

export const StyledHomePage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;